{
	"common": {
		"cancel": "Cancel",
		"save": "Save",
		"discard": "Discard changes",
		"reload": "Reload",
		"optional": "Optional",
		"stale": "Someone else changed this while you had it open. Reload to see the latest version, then try again."
	},
	"tabs": {
		"label": "Merchandising sections",
		"orders": "Orders",
		"products": "Products",
		"promos": "Promotions",
		"customers": "Customers",
		"outbox": "Outbox",
		"staff": "Staff",
		"toPack_one": "{{n}} paid order to pack",
		"toPack_other": "{{n}} paid orders to pack"
	},
	"summary": {
		"label": "Store summary",
		"ordersToday": "Orders today",
		"toFulfil": "To fulfil",
		"awaitingPayment": "Awaiting payment",
		"needsRefund": "Needs refund",
		"revenue": "Revenue (paid)",
		"lowStock": "Low-stock variants",
		"customers": "Customers"
	},
	"status": {
		"label": {
			"PENDING_PAYMENT": "Awaiting payment",
			"PAID": "Paid",
			"PACKING": "Packing",
			"SHIPPED": "Shipped",
			"DELIVERED": "Delivered",
			"CANCELLED": "Cancelled",
			"REFUNDED": "Refunded"
		},
		"hint": {
			"PENDING_PAYMENT": "Placed; stock is held while the shopper pays",
			"PAID": "Payment received; ready to pack",
			"PACKING": "Being packed in the warehouse",
			"SHIPPED": "Handed to the courier, with a tracking number",
			"DELIVERED": "Received by the shopper",
			"CANCELLED": "Cancelled before payment; stock returned",
			"REFUNDED": "Money returned to the shopper"
		},
		"collectReady": "Ready for collection",
		"collected": "Collected"
	},
	"payment": {
		"status": {
			"PENDING": "Pending",
			"SUCCEEDED": "Succeeded",
			"FAILED": "Failed",
			"EXPIRED": "Expired",
			"REFUNDED": "Refunded"
		},
		"hint": {
			"PENDING": "The shopper is still on the payment page",
			"SUCCEEDED": "The payment went through",
			"FAILED": "The bank, card or wallet refused it",
			"EXPIRED": "Nobody answered in time",
			"REFUNDED": "The payment was given back"
		},
		"method": {
			"FPX": "FPX online banking",
			"CARD": "Card",
			"EWALLET": "E-wallet",
			"DUITNOW_QR": "DuitNow QR"
		},
		"provider": {
			"SANDBOX": "Sandbox (test payments)"
		},
		"brand": {
			"VISA": "Visa",
			"MASTERCARD": "Mastercard"
		},
		"failure": {
			"declined": "Declined by the bank or issuer",
			"insufficient": "Insufficient funds",
			"expired_card": "The card has expired",
			"otp_failed": "Wrong one-time code three times",
			"timed_out": "Nobody answered in time",
			"not_test_card": "Not a sandbox test card (never processed)",
			"order_closed": "The order was no longer waiting for payment"
		},
		"col": {
			"started": "Started",
			"method": "Method",
			"detail": "Details",
			"amount": "Amount",
			"status": "Status"
		},
		"card": "{{brand}} •••• {{last4}}",
		"settled": "Settled {{at}}"
	},
	"delivery": {
		"method": {
			"STANDARD": "Standard — Malaysia",
			"NEXT_DAY": "Next working day",
			"COLLECT": "Collect at a Games store",
			"ASEAN": "ASEAN shipping"
		}
	},
	"colour": {
		"navy": "Navy",
		"red": "Red",
		"yellow": "Yellow",
		"gold": "Gold",
		"white": "White",
		"ink": "Ink",
		"sand": "Sand"
	},
	"category": {
		"Apparel": "Apparel",
		"Headwear": "Headwear",
		"Fan Gear": "Fan gear",
		"Bags": "Bags",
		"Drinkware": "Drinkware",
		"Tuah": "Tuah (mascot)",
		"Collectibles": "Collectibles",
		"Home": "Home"
	},
	"collection": {
		"team-malaysia": "Team Malaysia",
		"tuah": "Tuah",
		"batik": "Batik",
		"collect": "Collector series",
		"para": "Para Games",
		"core": "Core range"
	},
	"kind": {
		"tee": "T-shirt",
		"jersey": "Jersey",
		"hoodie": "Hoodie",
		"cap": "Cap",
		"scarf": "Scarf",
		"flag": "Flag",
		"tote": "Tote bag",
		"bottle": "Bottle",
		"plush": "Plush toy",
		"pin": "Pin",
		"keyring": "Keyring",
		"towel": "Towel",
		"poster": "Poster"
	},
	"tag": {
		"new": "New",
		"bestseller": "Bestseller",
		"sale": "Sale",
		"limited": "Limited"
	},
	"guide": {
		"title": "Order and payment statuses",
		"orders": "Orders",
		"collect": "Store collection",
		"collectNote": "An order collected at a Games store has no courier, so two steps read differently.",
		"collectReadyHint": "Packed and waiting at the store (shown instead of Shipped)",
		"collectedHint": "Picked up by the shopper (shown instead of Delivered)",
		"payments": "Payment attempts",
		"markers": "Markers"
	},
	"orders": {
		"title": "Orders",
		"count_one": "{{n}} order",
		"count_other": "{{n}} orders",
		"search": "Order number or customer email",
		"chips": {
			"status": "Status"
		},
		"needsRefund": "Needs refund",
		"needsRefundHint": "A payment went through after the order was cancelled. Refund it.",
		"noPayment": "No payment yet",
		"trackingShort": "Tracking {{no}}",
		"table": {
			"order": "Order",
			"customer": "Customer",
			"items": "Items",
			"total": "Total",
			"status": "Status",
			"payment": "Payment",
			"delivery": "Delivery"
		},
		"pager": {
			"showing_one": "Showing {{from}} to {{to}} of {{total}} order",
			"showing_other": "Showing {{from}} to {{to}} of {{total}} orders",
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No orders"
		},
		"empty": {
			"filteredTitle": "No orders match",
			"filteredHint": "Try another status or search, or clear the filters.",
			"clear": "Clear filters",
			"none": "No orders yet",
			"noneHint": "Orders placed in the store appear here."
		}
	},
	"bulk": {
		"selected_one": "{{n}} selected",
		"selected_other": "{{n}} selected",
		"clear": "Clear selection",
		"tooMany": "Pick at most {{max}} orders at a time",
		"action": {
			"PACKING": "Mark packing ({{n}})",
			"DELIVERED": "Mark delivered ({{n}})"
		},
		"confirmTitle": {
			"PACKING_one": "Mark {{n}} order as packing",
			"PACKING_other": "Mark {{n}} orders as packing",
			"DELIVERED_one": "Mark {{n}} order as delivered",
			"DELIVERED_other": "Mark {{n}} orders as delivered"
		},
		"confirmHint": {
			"PACKING": "Paid orders move to Packing. The shoppers see it in their order history.",
			"DELIVERED": "Shipped orders move to Delivered (collected, for store pick-up). The shoppers get an email."
		},
		"confirm": {
			"PACKING": "Mark packing",
			"DELIVERED": "Mark delivered"
		},
		"leftOut_one": "{{n}} selected order cannot take this step and is left out.",
		"leftOut_other": "{{n}} selected orders cannot take this step and are left out.",
		"done": {
			"PACKING_one": "{{n}} order marked as packing",
			"PACKING_other": "{{n}} orders marked as packing",
			"DELIVERED_one": "{{n}} order marked as delivered",
			"DELIVERED_other": "{{n}} orders marked as delivered"
		},
		"skippedToast_one": "{{n}} order was not changed: {{list}}",
		"skippedToast_other": "{{n}} orders were not changed: {{list}}",
		"skipItem": "{{ref}} ({{reason}})",
		"skipReason": {
			"not_found": "not found",
			"invalid_transition": "its status does not allow it",
			"changed": "it changed meanwhile, try again"
		},
		"failed": "Couldn't update the orders"
	},
	"order": {
		"back": "Back to orders",
		"placed": "Placed {{at}}",
		"payBy": "Payment due by {{at}}",
		"statusNote": "Note: {{note}}",
		"customer": "Customer",
		"delivery": "Delivery",
		"store": "Store: {{store}}",
		"shipment": "Shipment",
		"noShipment": "Not shipped yet",
		"noShipmentCollect": "Collected at the store, no courier",
		"totals": "Totals",
		"subtotal": "Subtotal {{amount}}",
		"discount": "Discount −{{amount}}",
		"discountCode": "Discount −{{amount}} ({{code}})",
		"deliveryFee": "Delivery {{amount}}",
		"total": "Total {{amount}}",
		"restocked": "Stock was put back",
		"linesTitle_one": "{{n}} item",
		"linesTitle_other": "{{n}} items",
		"line": {
			"product": "Product",
			"variant": "Colour and size",
			"sku": "SKU",
			"qty": "Qty",
			"unit": "Unit price",
			"total": "Line total",
			"size": "Size {{size}}"
		},
		"paymentsTitle": "Payment attempts",
		"noPayments": "No payment attempts yet",
		"timelineTitle": "Timeline",
		"notYet": "Not yet",
		"refundLate": "Refund late payment",
		"refundLateTitle": "Refund the late payment",
		"refundLateHint": "This order was cancelled, then a payment for it went through. Refund that payment to the shopper.",
		"refundLateDone": "Late payment refunded for {{ref}}",
		"refundLateFailed": "Couldn't refund the payment"
	},
	"move": {
		"action": {
			"PACKING": "Start packing",
			"SHIPPED": "Mark shipped",
			"SHIPPED_COLLECT": "Ready for collection",
			"DELIVERED": "Mark delivered",
			"DELIVERED_COLLECT": "Mark collected",
			"CANCELLED": "Cancel order",
			"REFUNDED": "Refund"
		},
		"title": {
			"PACKING": "Start packing this order",
			"SHIPPED": "Mark this order as shipped",
			"SHIPPED_COLLECT": "Mark this order ready for collection",
			"DELIVERED": "Mark this order as delivered",
			"DELIVERED_COLLECT": "Mark this order as collected",
			"CANCELLED": "Cancel this order",
			"REFUNDED": "Refund this order"
		},
		"hint": {
			"PACKING": "The shopper sees that the order is being packed.",
			"SHIPPED": "Give the courier and the tracking number. The shopper gets them by email.",
			"SHIPPED_COLLECT": "The shopper gets an email that the order is waiting at the store.",
			"DELIVERED": "The shopper received the parcel.",
			"DELIVERED_COLLECT": "The shopper picked the order up at the store.",
			"CANCELLED": "The order is closed and its reserved stock is returned. The shopper sees your reason.",
			"REFUNDED": "The money goes back to the shopper. The shopper sees your reason."
		},
		"done": {
			"PACKING": "{{ref}} is being packed",
			"SHIPPED": "{{ref}} marked as shipped",
			"SHIPPED_COLLECT": "{{ref}} is ready for collection",
			"DELIVERED": "{{ref}} marked as delivered",
			"DELIVERED_COLLECT": "{{ref}} marked as collected",
			"CANCELLED": "{{ref}} cancelled",
			"REFUNDED": "{{ref}} refunded"
		},
		"failed": "Couldn't change the order",
		"courier": "Courier",
		"courierPlaceholder": "e.g. Pos Laju",
		"tracking": "Tracking number",
		"courierRequired": "Enter the courier.",
		"trackingRequired": "Enter the tracking number.",
		"noteLabel": "Note",
		"noteRequiredLabel": "Reason",
		"noteRequired": "Give a reason. The shopper sees it.",
		"noteHint": "Shown on the shopper's order and kept in the activity log.",
		"restock": "Put the items back in stock",
		"restockHint": "Tick when the goods came back unused and can be sold again."
	},
	"products": {
		"title": "Products",
		"count_one": "{{n}} product",
		"count_other": "{{n}} products",
		"intro": "The store's catalogue. Open a product to edit its variants, stock and photos.",
		"full": "The catalogue holds the maximum of {{max}} products. Hide or reuse one to add another.",
		"new": "New product",
		"search": "Search name or slug",
		"active": "Active",
		"hidden": "Hidden",
		"chips": {
			"active": "Visibility"
		},
		"table": {
			"product": "Product",
			"category": "Category",
			"price": "Price",
			"variants": "Variants",
			"stock": "Stock",
			"active": "Visibility",
			"updated": "Updated"
		},
		"pagination": {
			"summary_one": "{{from}}–{{to}} of {{total}} product",
			"summary_other": "{{from}}–{{to}} of {{total}} products",
			"empty": "No products"
		},
		"empty": {
			"filteredTitle": "No products match",
			"filteredHint": "Try another search, or clear the filters.",
			"clear": "Clear filters",
			"none": "No products yet",
			"noneHint": "Create the first product to start selling."
		}
	},
	"product": {
		"back": "Back to products",
		"updated": "Last updated {{at}}",
		"detailsTitle": "Details",
		"newTitle": "New product",
		"newHint": "Add the variants (colour, size, stock) and photos on the next page.",
		"create": "Create product",
		"created": "{{name}} created",
		"createFailed": "Couldn't create the product",
		"saved": "{{name}} saved",
		"saveFailed": "Couldn't save the product",
		"field": {
			"name": "Name",
			"slug": "Web address name",
			"slugHint": "Lower-case letters, digits and single dashes. It is part of the product's link.",
			"category": "Category",
			"collection": "Collection",
			"kind": "Drawing",
			"kindHint": "The outline the store shows while the product has no photo.",
			"position": "Order",
			"positionHint": "Lower numbers show first.",
			"price": "Price (RM)",
			"wasPrice": "Old price (RM)",
			"wasPriceHint": "Shown struck through, for a sale. Must be higher than the price.",
			"tags": "Tags",
			"description": "Description",
			"active": "Show in the store",
			"activeHint": "Hidden products cannot be bought; existing orders are not affected."
		},
		"err": {
			"nameRequired": "Enter a name.",
			"slugRequired": "Enter a web address name.",
			"slugInvalid": "Use lower-case letters, digits and single dashes only.",
			"slugTaken": "Another product already uses this web address name.",
			"tooLong": "At most {{max}} characters.",
			"price": "Enter an amount above 0 and up to {{max}}, with at most 2 decimals.",
			"wasPrice": "The old price must be higher than the price.",
			"position": "Enter a whole number, 0 or more.",
			"invalid": "This value is not valid."
		}
	},
	"variants": {
		"title_one": "{{n}} variant",
		"title_other": "{{n}} variants",
		"totalStock": "{{n}} in stock (active variants)",
		"none": "No variants yet",
		"noneHint": "Add a colour and size for each item the store sells, with its stock.",
		"add": "Add variant",
		"save": "Save variants",
		"saved_one": "{{n}} variant saved",
		"saved_other": "{{n}} variants saved",
		"saveFailed": "Couldn't save the variants",
		"full": "A product can have at most {{max}} variants",
		"oneSize": "One size",
		"remove": "Remove variant {{sku}}",
		"removeSoldHint": "Remove this variant. If it has been sold, the store keeps it and only hides it.",
		"col": {
			"colour": "Colour",
			"size": "Size",
			"sku": "SKU",
			"stock": "Stock",
			"active": "On sale",
			"remove": "Remove"
		},
		"err": {
			"duplicatePair": "This colour and size is already on the list.",
			"sku": "Use capital letters, digits and single dashes.",
			"duplicateSku": "Another variant already uses this SKU.",
			"stock": "Enter a whole number from 0 to {{max}}."
		}
	},
	"images": {
		"title_one": "{{n}} of {{max}} photo",
		"title_other": "{{n}} of {{max}} photos",
		"colour": "Colourway",
		"anyColour": "Every colour",
		"upload": "Upload photo",
		"uploading": "Uploading… {{pct}}%",
		"uploaded": "Photo added",
		"uploadFailed": "Couldn't upload the photo",
		"rules": "JPEG, PNG or WebP, up to {{mb}} MB. Location data is removed.",
		"full": "This product has the most photos it can hold. Delete one to add another.",
		"badType": "Use a JPEG, PNG or WebP image.",
		"tooLarge": "The photo is larger than {{mb}} MB.",
		"none": "No photos yet",
		"noneHint": "Until a photo is added, the store shows the product's drawing.",
		"static": "Built in",
		"delete": "Delete photo",
		"deleteTitle": "Delete this photo?",
		"deleteHint": "The photo is removed from the store and deleted from storage.",
		"deleteStaticHint": "This built-in photo is removed from the product. The file shipped with the store stays.",
		"deleted": "Photo deleted",
		"deleteFailed": "Couldn't delete the photo"
	},
	"promos": {
		"title": "Promotions",
		"count_one": "{{n}} code",
		"count_other": "{{n}} codes",
		"intro": "Discount codes shoppers type at checkout.",
		"new": "New promotion",
		"edit": "Edit {{code}}",
		"percentOff": "{{n}}% off",
		"amountOff": "{{amount}} off",
		"minSubtotal": "On orders from {{amount}}",
		"from": "From",
		"until": "Until",
		"anytime": "any time",
		"noEnd": "no end",
		"usesOf": "{{n}} of {{max}}",
		"active": "Active",
		"inactive": "Off",
		"table": {
			"code": "Code",
			"discount": "Discount",
			"window": "Valid",
			"uses": "Used",
			"active": "State"
		},
		"pagination": {
			"summary_one": "{{from}}–{{to}} of {{total}} code",
			"summary_other": "{{from}}–{{to}} of {{total}} codes",
			"empty": "No codes"
		},
		"empty": {
			"none": "No promotions yet",
			"noneHint": "Create a code to offer a discount."
		},
		"kind": {
			"PERCENT": "Percent off",
			"FIXED": "Amount off (RM)"
		},
		"newTitle": "New promotion",
		"newHint": "The discount applies to the goods, never to delivery.",
		"editTitle": "Edit {{code}}",
		"usedTimes_one": "Used on {{n}} order so far.",
		"usedTimes_other": "Used on {{n}} orders so far.",
		"create": "Create promotion",
		"created": "{{code}} created",
		"saved": "{{code}} saved",
		"createFailed": "Couldn't create the promotion",
		"saveFailed": "Couldn't save the promotion",
		"field": {
			"code": "Code",
			"codeHint": "Capital letters and digits, what shoppers type.",
			"kind": "Type",
			"percent": "Percent off",
			"amount": "Amount off (RM)",
			"minSubtotal": "Minimum spend (RM)",
			"minSubtotalHint": "0 = any order.",
			"startsAt": "Starts",
			"endsAt": "Ends",
			"yourClock": "In your own time zone.",
			"maxUses": "Most orders",
			"maxUsesHint": "Empty = no limit.",
			"active": "Active",
			"activeHint": "An inactive code is refused at checkout."
		},
		"err": {
			"code": "Use 2 to {{max}} capital letters and digits.",
			"codeTaken": "Another promotion already uses this code.",
			"value": "Enter a value above 0 and up to {{max}}.",
			"wholePercent": "Use a whole percent.",
			"min": "Enter 0 or a positive amount.",
			"window": "The end must be after the start.",
			"maxUses": "Enter a whole number, 1 or more."
		}
	},
	"customers": {
		"title": "Customers",
		"count_one": "{{n}} account",
		"count_other": "{{n}} accounts",
		"intro": "Store shopper accounts. These are not GMS logins.",
		"search": "Exact email address",
		"chips": {
			"status": "Status"
		},
		"status": {
			"ACTIVE": "Active",
			"DISABLED": "Disabled"
		},
		"table": {
			"customer": "Customer",
			"orders": "Orders",
			"spent": "Spent",
			"status": "Status",
			"joined": "Joined"
		},
		"pager": {
			"showing_one": "Showing {{from}} to {{to}} of {{total}} account",
			"showing_other": "Showing {{from}} to {{to}} of {{total}} accounts",
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No accounts"
		},
		"empty": {
			"filteredTitle": "No accounts match",
			"exactHint": "The search needs the full email address, exactly.",
			"filteredHint": "Try the other status, or clear the filters.",
			"clear": "Clear filters",
			"none": "No accounts yet",
			"noneHint": "Shoppers who sign up in the store appear here."
		},
		"disable": "Disable",
		"enable": "Enable",
		"disableTitle": "Disable {{email}}?",
		"enableTitle": "Enable {{email}}?",
		"disableHint": "The shopper is signed out and cannot sign in or order until the account is enabled again.",
		"enableHint": "The shopper can sign in and order again.",
		"reason": "Reason",
		"reasonHint": "Kept in the activity log.",
		"reasonRequired": "Give a reason.",
		"disabled": "{{email}} disabled",
		"enabled": "{{email}} enabled",
		"statusFailed": "Couldn't change the account"
	},
	"outbox": {
		"title": "Outbox",
		"intro": "Emails the store would send. They are simulated: nothing leaves the server.",
		"view": "Open {{subject}}",
		"meta": "To {{to}} · {{at}}",
		"links": "Links",
		"linksHidden": "Links are hidden on this server, so one-time links never show on a shared screen.",
		"noLinks": "This email has no links.",
		"table": {
			"sent": "Sent",
			"to": "To",
			"subject": "Subject"
		},
		"template": {
			"VERIFY_EMAIL": "Verify email",
			"ACCOUNT_EXISTS": "Account already exists",
			"RESET_PASSWORD": "Reset password",
			"ORDER_PLACED": "Order placed",
			"ORDER_PAID": "Order paid",
			"ORDER_SHIPPED": "Order shipped",
			"ORDER_READY_FOR_COLLECTION": "Ready for collection",
			"ORDER_DELIVERED": "Order delivered",
			"ORDER_CANCELLED": "Order cancelled",
			"ORDER_REFUNDED": "Order refunded"
		},
		"pager": {
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No emails"
		},
		"empty": {
			"none": "No emails yet",
			"noneHint": "Sign-ups, password resets and order updates appear here."
		}
	},
	"staff": {
		"title": "Staff",
		"count_one": "{{n}} admin",
		"count_other": "{{n}} admins",
		"intro": "The admin logins that may run the store desk. Super admins always can and are not listed.",
		"add": "Add admin",
		"addTitle": "Add an admin to the store desk",
		"addHint": "Only logins that hold the Admin role can be added. They get access on their next request.",
		"added": "{{name}} can now use the store desk",
		"already": "{{name}} was already on the list",
		"addFailed": "Couldn't add the admin",
		"searchLabel": "Search admin logins",
		"searchPlaceholder": "Name, username or email",
		"searchButton": "Search",
		"pick": "Admin login",
		"pickPlaceholder": "Pick an admin",
		"pickHint_one": "{{count}} admin login found",
		"pickHint_other": "{{count}} admin logins found",
		"loading": "Loading…",
		"noAdmins": "No admin logins match",
		"by": "by {{name}}",
		"remove": "Remove {{name}}",
		"removeTitle": "Remove from the store desk?",
		"removeHint": "{{name}} loses access to Merchandising on their next request. Their login is not changed.",
		"removeConfirm": "Remove",
		"removed": "{{name}} removed from the store desk",
		"removeFailed": "Couldn't remove the admin",
		"table": {
			"name": "Admin",
			"status": "Login status",
			"added": "Added"
		},
		"pagination": {
			"summary_one": "{{from}}–{{to}} of {{total}} admin",
			"summary_other": "{{from}}–{{to}} of {{total}} admins",
			"empty": "No admins"
		},
		"empty": {
			"none": "No admins on the list",
			"noneHint": "Only super admins can use the store desk until you add an admin."
		}
	}
}
